var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(56.470588%,56.078431%,63.529412%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18.179688 8.039062 L 18.644531 7.574219 C 19.410156 6.808594 20.65625 6.808594 21.425781 7.574219 C 22.191406 8.34375 22.191406 9.589844 21.425781 10.355469 L 20.960938 10.820312 M 18.179688 8.039062 C 18.179688 8.039062 18.238281 9.023438 19.105469 9.894531 C 19.976562 10.761719 20.960938 10.820312 20.960938 10.820312 M 18.179688 8.039062 L 13.917969 12.300781 C 13.628906 12.589844 13.488281 12.734375 13.363281 12.890625 C 13.214844 13.078125 13.089844 13.28125 12.988281 13.496094 C 12.902344 13.679688 12.835938 13.875 12.707031 14.261719 L 12.292969 15.5 L 12.160156 15.902344 M 20.960938 10.820312 L 16.699219 15.082031 C 16.410156 15.371094 16.265625 15.511719 16.109375 15.636719 C 15.921875 15.785156 15.71875 15.910156 15.503906 16.011719 C 15.320312 16.097656 15.125 16.164062 14.738281 16.292969 L 13.5 16.707031 L 13.097656 16.839844 M 13.097656 16.839844 L 12.699219 16.972656 C 12.507812 17.035156 12.296875 16.988281 12.15625 16.84375 C 12.011719 16.703125 11.964844 16.492188 12.027344 16.300781 L 12.160156 15.902344 M 13.097656 16.839844 L 12.160156 15.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(56.470588%,56.078431%,63.529412%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8 13 L 10.5 13 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(56.470588%,56.078431%,63.529412%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8 9 L 14.5 9 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(56.470588%,56.078431%,63.529412%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8 17 L 9.5 17 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(56.470588%,56.078431%,63.529412%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 19.828125 3.171875 C 18.65625 2 16.769531 2 13 2 L 11 2 C 7.230469 2 5.34375 2 4.171875 3.171875 C 3 4.34375 3 6.230469 3 10 L 3 14 C 3 17.769531 3 19.65625 4.171875 20.828125 C 5.34375 22 7.230469 22 11 22 L 13 22 C 16.769531 22 18.65625 22 19.828125 20.828125 C 20.773438 19.886719 20.957031 18.480469 20.992188 16 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPost);
export default __webpack_public_path__ + "static/media/report_post.4aded082e609ca3ce03c10d3f2800ebc.svg";
export { ForwardRef as ReactComponent };